import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { getTokenExpiration, getRoleId } from "Common/Components/getRoleId";
// هاویر کشت
import factoryRegiste from "../pages/factoryRegiste/index";
import CityRegiste from "../pages/CityRegiste/index";
import NavTabs from "pages/Components/Navigation/Tabs";
import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/LogOut";
import UserProfile from "pages/Authentication/UserProfile";
import Settings from "pages/Pages/Settings";
import ProvincialRegistration from "pages/ProvincialRegistration/Index";
import MeasurementPage from "pages/Measurement/index";
import CommissionPercentage from "pages/CommissionPercentage/index";
import ContractorPhoneSettings from "pages/ContractorPhoneSettings/index";
import landingpage from "pages/Product/index";
import villageRegister from "pages/villageRegister/index";
import NotFound from "pages/NoteFound";
import PoisonPage from "pages/PoisonPage";
import SeedPage from "pages/SeedPage";
import PaymentTitle from "pages/PaymentTitle/PaymentTitle";
import ProductPage from "pages/ProductPage/ProductPage";
import ManageUser from "pages/ManageUser";
import ProductPriceInCropYearPage from "pages/ProductPriceInCropYearPage/ProductPriceInCropYearPage";
import Cutie from "pages/Cutie/Cutie";
import FarmerPage from "pages/FarmerPage/FarmerPage";
import ContactUS from "pages/ContactUS/ContactUS";
import DashBoard from "pages/DashBoard/DashBoard";
import YearRegistration from "pages/YearRegistration/YearRegistration";
import FactoryregistrationPayment from "pages/FactoryregistrationPayment/FactoryregistrationPayment";
import RegisterBazeFactory from "pages/registerBazeFactory/RegisterBazeFactory";
import RegisterPoisonFactory from "pages/registerPoisonFactory/RegisterPoisonFactory";
import Commitment from "pages/Commitment/Commitment";
import PoisonDeliveryFarmer from "pages/PoisonDeliveryFarmer/PoisonDeliveryFarmer";
import SeedFarmer from "pages/SeedFarmer/SeedFarmer";
import PlacedFarmer from "pages/placed-farmer/PlacedFarmer";
import PaymentFarmerForop from "pages/PayMentFarmerForopration/PaymentFarmerForop";
import Cargo from "pages/Cargo/Cargo";
import CargoDeficitFare from "pages/CargoDeficitFare/CargoDeficitFare";
import ChatBot from "pages/ChatBotTest/ChatBot";
import SendSmsFarmer from "Common/Components/SendSmsFarmer";
import PaymentFarmer2 from "pages/PaymentFarmer2";
import RepotSeed from "pages/ReportSeed/index";
import RepostPoison from "pages/RepostPoison/index";
import AllReport from "pages/AllReport/index";
import Burdenfarmers from "pages/Burdenfarmers/index";
import Guarantee2 from "pages/Guarantee2/index";
import InvoiceFarmer from "pages/InvoiceFarmerPage/index";
import sugerFactory from "pages/sugerFactory/index";
import FactoryWaste from "pages/FactoryWaste/index";
import Resivewast from "pages/Resivewast/index";
import Resivsuger from "pages/Resivsuger/index";
import ReportSuger from "pages/ReportSuger/index";
import ReportWaste from "pages/ReportWaste/index";
import MainFullReport from "pages/MainFullReport";
import UserDashboard from "pages/UserDashBoard";
import YourCommitment from "pages/AllPageForFarmer";
import WastFarmer from "pages/AllPageForFarmer/WastFarmer";
import Yoursugar from "pages/AllPageForFarmer/Yoursugar";
import Yourguarantees from "pages/AllPageForFarmer/Yourguarantees";
import Yourpayments from "pages/AllPageForFarmer/Yourpayments";
import YourSeeds from "pages/AllPageForFarmer/YourSeeds";
import YourPesticides from "pages/AllPageForFarmer/YourPesticides";
import YourDeliveries from "pages/AllPageForFarmer/YourDeliveries";
import Registerdriver from "pages/Registerdriver/Registerdriver";
import RegisterCar from "pages/RegisterCar/RegisterCar";
import ReadyLoad from "pages/ReadyLoad/ReadyLoad";
import { DEFAULT_CROP_YEAR_ID } from "Common/constants/cropYear";
const Routepage = () => {
  const navigation = useNavigate();
  const [userRole, setUserRole] = useState<any>(() =>
    getRoleId(localStorage.getItem("app_atkey") || 2)
  );
  useEffect(() => {
    const token = localStorage.getItem("app_atkey");
    if (!token) {
      localStorage.clear();
      navigation("/landingpage");
    }
  }, []);

  const expierationToken = localStorage.getItem("app_atkey") || "";
  const cropYearID = localStorage.getItem("crop_year_id");
  useEffect(() => {
    const token = localStorage.getItem("app_atkey");
    if (userRole === 5) {
      // code
      localStorage.setItem("crop_year_id", String(DEFAULT_CROP_YEAR_ID));
    } else if (token && !cropYearID && !Number(cropYearID)) {
      navigation("/Year-registration");
    } 
    const feachData = async () => {
      const tokenExpiration = getTokenExpiration(
        localStorage.getItem("app_atkey")
      );
      const newTimestamp = Number(expierationToken) + 1800000;
      if (tokenExpiration && tokenExpiration?.getTime() < newTimestamp) {
        toast.error("نشست شما تمام شده لطفا مجدد وارد شوید");
        navigation("/login");
        localStorage.removeItem("app_atkey");
        localStorage.removeItem("app_rtkey");
      }
    };
    feachData();
  }, [navigation]);

  useEffect(() => {
    setUserRole(getRoleId(localStorage.getItem("app_atkey")));
  });

  const authProtectedRoutes: Array<any> = [
    // هاویر کشت
    {
      path: "/factoryRegiste",
      component: factoryRegiste,
      rolesAllowed: [1],
    },
    {
      path: "/Year-registration",
      component: YearRegistration,
      rolesAllowed: [1, 3, 5],
    },
    {
      path: "/ProvincialRegistration",
      component: ProvincialRegistration,
      rolesAllowed: [1],
    },
    {
      path: "/MeasurementPage",
      component: MeasurementPage,
      rolesAllowed: [1],
    },
    {
      path: "/CutiePage",
      component: Cutie,
      rolesAllowed: [1],
    },
    {
      path: "/CommissionPercentagePage",
      component: CommissionPercentage,
      rolesAllowed: [1],
    },
    {
      path: "/ContractorPhoneSettingsPage",
      component: ContractorPhoneSettings,
      rolesAllowed: [1],
    },
    {
      path: "/SeedPage",
      component: SeedPage,
      rolesAllowed: [1],
    },
    {
      path: "/manageUser",
      component: ManageUser,
      rolesAllowed: [1],
    },
    {
      path: "/FarmerPage",
      component: FarmerPage,
      rolesAllowed: [1],
    },
    {
      path: "/ReadyLoad",
      component: ReadyLoad,
      rolesAllowed: [1, 5],
    },

    {
      path: "/Registerdriver",
      component: Registerdriver,
      rolesAllowed: [1, 5],
    },

    {
      path: "/PaymentTitlePage",
      component: PaymentTitle,
      rolesAllowed: [1],
    },
    {
      path: "/ProductPage",
      component: ProductPage,
      rolesAllowed: [1],
    },
    {
      path: "/DashBoard",
      component: DashBoard,
      rolesAllowed: [1],
    },
    {
      path: "/ContactUS",
      component: ContactUS,
      rolesAllowed: [1, 3, 5],
    },
    {
      path: "/PoisonPage",
      component: PoisonPage,
      rolesAllowed: [1],
    },
    {
      path: "/villageRegister",
      component: villageRegister,
      rolesAllowed: [1],
    },
    { path: "/CityRegiste", component: CityRegiste, rolesAllowed: [1] },
    {
      path: "/ProductPriceInCropYearPage",
      component: ProductPriceInCropYearPage,
      rolesAllowed: [1],
    },
    {
      path: "/resive_wast",
      component: Resivewast,
      rolesAllowed: [1],
    },

    {
      path: "/registerPoisonFactory",
      component: RegisterPoisonFactory,
      rolesAllowed: [1],
    },
    {
      path: "/placed-farmer",
      component: PlacedFarmer,
      rolesAllowed: [1],
    },
    {
      path: "/resive_sugar",
      component: Resivsuger,
      rolesAllowed: [1],
    },
    {
      path: "Report/ReportWaste",
      component: ReportWaste,
      rolesAllowed: [1],
    },

    {
      path: "/userDashboard",
      component: UserDashboard,
      rolesAllowed: [1, 3],
    },
    {
      path: "/Burden_of_farmers",
      component: Burdenfarmers,
      rolesAllowed: [1],
    },
    {
      path: "/Report/invoice_Farmer",
      component: InvoiceFarmer,
      rolesAllowed: [1],
    },
    {
      path: "/FactoryWaste",
      component: FactoryWaste,
      rolesAllowed: [1],
    },

    {
      path: "/Guarantee2",
      component: Guarantee2,
      rolesAllowed: [1],
    },

    {
      path: "/FactoryregistrationPayment",
      component: FactoryregistrationPayment,
      rolesAllowed: [1],
    },
    {
      path: "/Commitment",
      component: Commitment,
      rolesAllowed: [1],
    },
    {
      path: "/SeedFactory",
      component: RegisterBazeFactory,
      rolesAllowed: [1],
    },
    // defult route
    { path: "*", component: NotFound, rolesAllowed: [1, 2, 3, 4] },
    // تب بندی
    { path: "/navigation-tabs", component: NavTabs, rolesAllowed: [1, 2] },
    // dynamic route
    {
      path: "/PoisonDelivery",
      component: PoisonDeliveryFarmer,
      rolesAllowed: [1],
    },
    {
      path: "/ChatBot",
      component: ChatBot,
      rolesAllowed: [1],
    },
    {
      path: "/CargoDeficitFare",
      component: CargoDeficitFare,
      rolesAllowed: [1],
    },
    {
      path: "/Cargo",
      component: Cargo,
      rolesAllowed: [1],
    },
    {
      path: "/SendSmsFarmer",
      component: SendSmsFarmer,
      rolesAllowed: [1],
    },
    {
      path: "/register/seedFarmer",
      component: SeedFarmer,
      rolesAllowed: [1],
    },
    {
      path: "/sugerFactory",
      component: sugerFactory,
      rolesAllowed: [1],
    },
    {
      path: "/registerCar",
      component: RegisterCar,
      rolesAllowed: [1],
    },

    {
      path: "/Report/RepostSeed",
      component: RepotSeed,
      rolesAllowed: [1],
    },
    {
      path: "/Report/ReportSuger",
      component: ReportSuger,
      rolesAllowed: [1],
    },

    {
      path: "/Report/RepostPoison",
      component: RepostPoison,
      rolesAllowed: [1],
    },
    {
      path: "/Report/FullReport",
      component: MainFullReport,
      rolesAllowed: [1],
    },

    {
      path: "/Report/Factory",
      component: AllReport,
      rolesAllowed: [1],
    },
    {
      path: "/PaymentFarmer2",
      component: PaymentFarmer2,
      rolesAllowed: [1],
    },

    {
      path: "/paymentFarmer",
      component: PaymentFarmerForop,
      rolesAllowed: [1],
    },

    {
      path: "/pages-account-settings",
      component: Settings,
      rolesAllowed: [1, 2, 3, 4],
    },
    {
      path: "/user-profile",
      component: UserProfile,
      rolesAllowed: [1, 2, 3, 4],
    },
    // for farmer //////////////////////////////////////
    {
      path: "/YourCommitment",
      component: YourCommitment,
      rolesAllowed: [3],
    },
    {
      path: "/YourWast",
      component: WastFarmer,
      rolesAllowed: [3],
    },
    {
      path: "/Yoursugar",
      component: Yoursugar,
      rolesAllowed: [3],
    },
    {
      path: "/Yourguarantees",
      component: Yourguarantees,
      rolesAllowed: [3],
    },
    {
      path: "/Yourpayments",
      component: Yourpayments,
      rolesAllowed: [3],
    },
    {
      path: "/YourSeeds",
      component: YourSeeds,
      rolesAllowed: [3],
    },
    {
      path: "/YourPesticides",
      component: YourPesticides,
      rolesAllowed: [3],
    },
    {
      path: "/YourDeliveries",
      component: YourDeliveries,
      rolesAllowed: [3],
    },
  ].filter((route) => route.rolesAllowed.includes(userRole));

  const filteredRoutes = authProtectedRoutes.filter((route) =>
    route.rolesAllowed.includes(userRole)
  );

  if (filteredRoutes.length === 0) {
    filteredRoutes.push({ path: "/login", component: NotFound });
  }
  if (!localStorage.getItem("app_atkey")) {
    filteredRoutes.push({ path: "/login", component: Login });
  }
  // pablic route

  const publicRoutes = [
    // authentication
    { path: "/login", component: Login },
    { path: "/logout", component: Logout },
    { path: "/landingpage", component: landingpage },
  ];
  return [authProtectedRoutes, publicRoutes];
};

export default Routepage;
